import { render, staticRenderFns } from "./CollapsibleItem.vue?vue&type=template&id=3a0c90d9&scoped=true"
import script from "./CollapsibleItem.vue?vue&type=script&lang=js"
export * from "./CollapsibleItem.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleItem.vue?vue&type=style&index=0&id=3a0c90d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c90d9",
  null
  
)

export default component.exports